import { CallTag } from '../CallTag';
import { CallTagModal, CallTagFormValues } from '../CallTagModal';

import { Flex } from '@aircall/tractor';
import { ListItem } from '@components/ListItem/ListItem';
import { TagsListQuery_getCompany_tags } from '@generated/TagsListQuery';
import { useToggle } from '@hooks/useToggle/useToggle';
import { useTranslation } from 'react-i18next';

interface ListCallTagItemProps {
  tag: TagsListQuery_getCompany_tags;
  namesBlacklist: string[];
  onDelete: (tag: TagsListQuery_getCompany_tags) => void;
  onEdit: (tag: TagsListQuery_getCompany_tags, values: CallTagFormValues) => void;
}

export function ListCallTagItem({ tag, onDelete, onEdit, namesBlacklist }: ListCallTagItemProps) {
  const [isModalOpen, _, openModal, closeModal] = useToggle();
  const { t } = useTranslation();

  function handleEdit(values: CallTagFormValues) {
    onEdit(tag, values);
    closeModal();
  }

  return (
    <ListItem
      key={tag.id}
      dropdownOptions={
        !tag.description
          ? [
              {
                title: t('calls.pages.tags.list.menu.edit_tag'),
                callback: openModal,
              },
              {
                title: t('calls.pages.tags.list.menu.delete_tag'),
                callback: () => onDelete(tag),
              },
            ]
          : undefined
      }
      data-test={`call-tag-list-item-${tag.id}`}
    >
      <Flex alignItems='center' justifyContent='space-between' width='100%' px='s'>
        <CallTag {...tag} />
      </Flex>
      <CallTagModal
        title={t('calls.pages.tags.edit_modal.title')}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleEdit}
        namesBlacklist={namesBlacklist.filter((tagName) => tagName !== tag.name)}
        initialValues={{
          name: tag.name,
          color: tag.color,
        }}
      />
    </ListItem>
  );
}
